export default "__VITE_ASSET__DcXyXKs3__"